import actionTypes from "./actionTypes";
import api from "./api";
export default {
    deleteProject: (projectId, workSpaceId) => ({
        type: actionTypes.DELETE_PROJECT,
        payload: {
            promise: () => api.deleteProject(projectId)
        },
        scope: `${actionTypes.DELETE_PROJECT}_${projectId}`,
        meta: {
            projectId,
            workSpaceId
        }
    })
};
